import type { JobSummaryContent } from '@xing-com/crate-common-graphql-types';

import { JobsXingletWrapper } from '../../../jobs-xinglet';

import { AiJobSummarySkeleton } from './ai-job-summary-skeleton';

export type AiJobSummaryProps = {
  summary?: JobSummaryContent;
  jobGlobalId: string;
};

export const AiJobSummary = JobsXingletWrapper<AiJobSummaryProps>(
  '@xing-com/crate-jobs-domain-job-details-ai-job-summary',
  <AiJobSummarySkeleton />
);
